import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { useAnimation } from '../../hooks/useAnimation';

import './Products.scss';

const Products = () => {
  const { t } = useTranslation();
  const { slideInLeft, bounceIn } = useAnimation();
  
  return (
    <section className="products-section">
      <Container>
        <Row className="align-items-center">
          <Col md={6}>
            <motion.div
              className="product-image"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={slideInLeft}
            >
              <img src={require('../../assets/images/tekstas.jpg')} alt="Product" />
            </motion.div>
          </Col>
          <Col md={6}>
            <motion.div
              className="product-content"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={bounceIn}
            >
              <h2 className="section-title">
                {t('about.title', 'Hakkımızda')}
              </h2>
              <p className="section-subtitle text-muted small mb-3" style={{ whiteSpace: 'pre-line' }}>
                {t('products.title')}
              </p>

            </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Products;